"use client";

import { create } from "zustand";
import type { AuthUser } from "@/lib/api/types";

type AuthState = {
  user: AuthUser | null;
  setUser: (u: AuthUser | null) => void;
  currentCompanyId: number | null;
  currentBranchId: number | null;
  setCurrentScope: (companyId: number | null, branchId: number | null) => void;
};

export const useAuth = create<AuthState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  currentCompanyId: null,
  currentBranchId: null,
  setCurrentScope: (currentCompanyId, currentBranchId) => set({ currentCompanyId, currentBranchId }),
}));
